import { InjectionToken } from '@angular/core';
import { INewRelicService } from './new-relic-service.interface';

export const NEW_RELIC_SERVICE_TOKEN = new InjectionToken<INewRelicService>('NEW_RELIC_SERVICE_TOKEN');